import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentDto } from '../../core/models/document.model';
import { I18nService } from '../../core/services/i18n.service';

@Component({
  selector: 'app-document-list',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="list-wrapper">
      <table *ngIf="documents.length > 0; else empty">
        <thead>
          <tr>
            <th>{{ i18n.t('documentList.code') }}</th>
            <th>{{ i18n.t('documentList.title') }}</th>
            <th>{{ i18n.t('documentList.type') }}</th>
            <th>{{ i18n.t('documentList.size') }}</th>
            <th>{{ i18n.t('documentList.description') }}</th>
            <th>{{ i18n.t('documentList.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of documents">
            <td>{{ item.documentCode }}</td>
            <td>
              <div class="title-cell">
                <button class="link-btn" type="button" (click)="open.emit(item)">{{ item.title }}</button>
                <span class="ocr-badge" *ngIf="item.hasExtractedText">{{ i18n.t('documentList.ocr') }}</span>
              </div>
            </td>
            <td>{{ item.fileExtension }}</td>
            <td>{{ item.sizeBytes | number }}</td>
            <td>{{ item.description }}</td>
            <td>
              <button type="button" (click)="open.emit(item)">{{ i18n.t('actions.open') }}</button>
              <button *ngIf="canDelete" class="danger" type="button" (click)="delete.emit(item)">{{ i18n.t('actions.delete') }}</button>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #empty>
        <div class="empty">{{ i18n.t('documentList.empty') }}</div>
      </ng-template>
    </div>
  `,
  styles: [`
    .list-wrapper { background:#fff; border:1px solid #e5e7eb; border-radius:16px; overflow:hidden; }
    table { width:100%; border-collapse:collapse; }
    th, td { padding:14px 16px; border-bottom:1px solid #f3f4f6; text-align:start; }
    th { background:#f9fafb; }
    .empty { padding:24px; text-align:center; color:#6b7280; }
    button { margin-inline-end:8px; border:0; background:#111827; color:#fff; padding:8px 12px; border-radius:8px; cursor:pointer; }
    .title-cell { display:flex; align-items:center; gap:8px; }
    .link-btn { margin-inline-end:0; padding:0; background:transparent; color:#1d4ed8; border-radius:0; }
    .link-btn:hover { text-decoration:underline; }
    .ocr-badge { display:inline-flex; align-items:center; justify-content:center; min-width:40px; height:22px; padding:0 8px; border-radius:999px; background:#dcfce7; color:#166534; font-size:12px; font-weight:700; letter-spacing:0.04em; }
    .danger { background: #b91c1c; }
  `]
})
export class DocumentListComponent {
  readonly i18n = inject(I18nService);
  @Input() documents: DocumentDto[] = [];
  @Input() canDelete = false;
  @Output() open = new EventEmitter<DocumentDto>();
  @Output() delete = new EventEmitter<DocumentDto>();
}
